import React from "react";
import { Box, Typography, Grid, Paper, Divider } from "@mui/material";
import { isMobile } from "react-device-detect";

const CertificateForm = ({ externalEntityName }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          نموذج التقديم
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{
          p: 3,
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
        }}
      >
        <Grid spacing={3} container>
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>
              الجهة الموجَّه إليها الكتاب
            </Typography>
            <Typography>
              {externalEntityName || "—"}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default CertificateForm;
